import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { DirectivesModule } from 'src/modules/directives/module';
import { MaterialModule } from 'src/app/material.module';
import { NotSoldBallotDashlet } from './components/dashlet/not-sold-ballot/component';
import { EventDashboard } from './components/dashboard/component';
import { EventModule } from 'src/modules/event/module';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    DirectivesModule,
    RouterModule,
    EventModule,
  ],
  declarations: [
    NotSoldBallotDashlet,
    EventDashboard
  ],
  exports: [
    NotSoldBallotDashlet,
    EventDashboard,
   
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class EventAdminModule {}
